module.exports = __webpack_public_path__ + "images/help/guide_video_me-2bcd693cc5c8b248bc29a47ff750df2f.png";